import React from "react";
import PropTypes from "prop-types";
import { withSize } from "react-sizeme";
import styles from "components/grid/cell-formatters/focus-cell-formatters.scss";
import { documentPropType } from "custom-prop-types";

const InputCell = ({
  accountId,
  document,
  documentCount,
  field,
  isFocused,
  onUpdateDocument,
  onUpdateInlineDocument,
  rowIndex,
  size,
  value
}) => {
  if (isFocused && !(document.type === "other" && field === "invoiceNumber")) {
    return (
      <div>
        <input
          className={ styles.input }
          defaultValue={ value }
          onBlur={ (e) => onUpdateInlineDocument({ accountId, document, field, value: e.target.value }) }
          onChange={ (e) => onUpdateDocument(field, e.target.value) }
          type="text"
        />
      </div>
    );
  }
  const length = value ? value.length * 5 : 0;
  const tooltipStyle = rowIndex < (documentCount / 2) ? styles["tooltip-bottom"] : styles["tooltip-top"];
  return (
    <div className={ styles.container }>
      { value }
      { renderTooltip(length, size, value, tooltipStyle) }
    </div>
  );
};

InputCell.defaultProps = {
  value: null
};

InputCell.propTypes = {
  accountId: PropTypes.string.isRequired,
  document: documentPropType.isRequired,
  documentCount: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  isFocused: PropTypes.bool.isRequired,
  onUpdateDocument: PropTypes.func.isRequired,
  onUpdateInlineDocument: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
  size: PropTypes.shape({ size: PropTypes.number }).isRequired,
  value: PropTypes.string
};

export const InputCellFormatter = withSize()(InputCell);

const renderTooltip = (length, size, value, tooltipStyle) => {
  if (length > size.width) {
    return (
      <div className={ tooltipStyle }>
        { value }
      </div>
    );
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/input-cell-formatter.jsx